import { QualityDocMeta } from '../../types/qualityPolicy';

interface Props {
  meta: QualityDocMeta;
  disabled?: boolean;
  onChange: (meta: QualityDocMeta) => void;
}

/** 결재란(StampBox)과 중복되는 작성자·검토·승인 정보는 두지 않음. 문서번호·작성일만 표시. */
function QualityDocMetaFields({ meta, disabled, onChange }: Props) {
  return (
    <div className="qform-section">
      <h3>문서 정보</h3>
      <div className="qform-grid qform-grid--3">
        <label>
          문서번호
          <input
            value={meta.docNo}
            readOnly
            disabled={disabled}
            placeholder={!meta.docNo ? '저장 시 자동 발급' : undefined}
          />
        </label>
        <label>
          작성일
          <input
            type="date"
            value={meta.preparedDate}
            disabled={disabled}
            onChange={(e) => onChange({ ...meta, preparedDate: e.target.value })}
          />
        </label>
      </div>
      <p className="qform-hint">
        작성·검토·승인 정보는 상단 결재란과 결재 이력에 남습니다.
      </p>
    </div>
  );
}

export default QualityDocMetaFields;
